import {ClsErrores} from '../../cls-errores';
import {ClsPeticionPresupuestos} from '../cls-pr-generico';
import {ClsInsumosCalculado} from '../../cls-catalogos';

// ------------------ Peticion general -----------
// peticion para todos los catalogos
export class ClsPeticionConsultarGralsCatalogos extends ClsPeticionPresupuestos {
  Limit: number;
  Offset: number;
}

export class ClsPeticionEliminarGralsCatalogos extends ClsPeticionPresupuestos {
  ListaIds: any;
}

export class ClsPeticionRegistraActualizaGralsCatalogos extends ClsPeticionPresupuestos {
  Catalogo: any[];
}

export class ClsPeticionCH extends ClsPeticionPresupuestos {
  ReporteCHBase64: string;
  Formato: string;
  TipoMoneda: number;
  OpcionEquipos: number;
  ConDescripcionLarga: boolean;
  EquipoInicial: string;
  EquipoFinal: string;
  LogoDep: string;
}

export class ClsRespuestaRegistraActualizaGralsCatalogos {
  ListaIds: bigint[];
  ListaIdsCodigo: any;
  Errores: ClsErrores;
}

export class ClsPeticionTipoInsumosCalculado extends ClsPeticionPresupuestos {
  TipoMoneda: number;
}

export class ClsRespuestaEnviaTipoInsumosCalculado {
  LsCatalogo: ClsInsumosCalculado[];
  Errores: ClsErrores;
}
// ------------- Fin peticion generales ----------
